import cmsApi from '../api/cms'
import { prepareFaqForPersist } from './faqUtils'

export async function persistPolymorphicFaq({ parentType, parentId, faqAbilitato, faqList }) {
  if (!parentId) return { ok: true }
  const { faq_abilitato, faq } = prepareFaqForPersist(faqAbilitato, faqList)
  return cmsApi.modificaFaqPolymorphic({
    parent_type: parentType,
    parent_id: parentId,
    faq_abilitato,
    faq,
  })
}

export function buildCmsPaginaFaqPayload(faqAbilitato, faqList) {
  return prepareFaqForPersist(faqAbilitato, faqList)
}
